import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ScoreVariationText(
    $variationId: ID!
    $text: String!
    $scoringMethod: ScoringMethodInput
  ) {
    scoreVariationText(variationId: $variationId, text: $text, scoringMethod: $scoringMethod) {
      score
      contentTaxonomyId
      ageScoreHistogram
      genderScoreHistogram
      engagementScoreSupportSize
      isEnterpriseScoreUsed
      language
      scoringMethod {
        id
        type
        name
      }
      secondaryScoringMethod {
        id
        type
        name
      }
    }
  }
`;

export const scoreVariationText = ({ variationId, text, scoringMethod }, options) => {
  const variables = {
    variationId,
    text,
    scoringMethod,
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
